import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import './About.css';
import { LanguageContext, getTranslation } from '../LanguageContext';
import { FaHistory, FaChild, FaPeopleCarry, FaCalendarAlt, FaEye } from 'react-icons/fa';

// Objeto de traducciones para el componente About
const aboutTranslations = {
  en: {
    ourHistory: "Our History",
    associationName: "National Association For The Protection Of Children",
    description: "The National Association for the Protection of Children is an organization that fights for every child to grow up in a healthy and safe environment. It works for the implementation of protective public policies, such as the creation of specialized reception centers and mobile police units dedicated to child protection. ANPE also fights against the exploitation of children in begging and offers them free legal, social, and administrative assistance.",
    ourMission: "Our Mission",
    missionDesc: "Fighting against the exploitation of children in begging",
    founded: "Founded",
    views: "Views"
  },
  fr: {
    ourHistory: "Notre Histoire",
    associationName: "Association Nationale Pour La Protection De L'enfance",
    description: "L'Association Nationale pour la Protection de l'Enfance est une organisation qui se bat pour que chaque enfant puisse grandir dans un environnement sain et sécurisé. Elle œuvre pour la mise en place de politiques publiques protectrices, telles que la création de centres d'accueil spécialisés et d'unités mobiles de police dédiées à la protection de l'enfance. L'ANPE lutte également contre l'exploitation des enfants dans la mendicité et leur offre une assistance juridique, sociale et administrative gratuite.",
    ourMission: "Notre Mission",
    missionDesc: "Lutter contre l'exploitation des enfants dans la mendicité",
    founded: "Fondé",
    views: "Vues"
  },
  ar: {
    ourHistory: "تاريخنا",
    associationName: "الجمعية الوطنية لحماية الطفولة",
    description: "الجمعية الوطنية لحماية الطفولة هي منظمة تكافح من أجل أن ينمو كل طفل في بيئة صحية وآمنة. تعمل من أجل تنفيذ سياسات عامة واقية، مثل إنشاء مراكز استقبال متخصصة ووحدات شرطة متنقلة مخصصة لحماية الأطفال. كما تكافح الجمعية ضد استغلال الأطفال في التسول وتقدم لهم مساعدة قانونية واجتماعية وإدارية مجانية.",
    ourMission: "مهمتنا",
    missionDesc: "مكافحة استغلال الأطفال في التسول",
    founded: "تأسست",
    views: "مشاهدات"
  }
};

const About = () => {
  const [viewed, setViewed] = useState(0);
  const [animatedViewed, setAnimatedViewed] = useState(0);
  
  // Usar el contexto de idioma
  const { language } = useContext(LanguageContext);
  
  // Función para obtener la traducción
  const translate = (key) => getTranslation(aboutTranslations, language, key);

  const handleFetch = () => {
    axios.post('http://localhost:4444/viewed/add')
      .then((res) => {
        const views = res.data.data?.views || 0;
        setViewed(views);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  useEffect(() => {
    handleFetch();
  }, []);

  useEffect(() => {
    let start = 0;
    const duration = 4000; // Duration of the animation in milliseconds
    const increment = viewed / (duration / 16); // Calculate the increment per frame

    const animate = () => {
      start += increment;
      if (start < viewed) {
        setAnimatedViewed(Math.round(start));
        requestAnimationFrame(animate);
      } else {
        setAnimatedViewed(viewed); // Ensure the final value is set
      }
    };

    animate();
  }, [viewed]);

  const formatNumber = (number) => {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  };

  // Determinar si el texto debe fluir de derecha a izquierda (para árabe)
  const isRTL = language === 'ar';

  return (
    <div className={`about ${isRTL ? 'rtl' : ''}`} id='about'>
      <div className='about_image'>
        <img 
          src='./image/About/group-people-volunteering-foodbank-poor-people.jpg' 
          alt={translate('ourHistory')}
          aria-label={translate('associationName')}
        />
      </div>
      <div className='about_container'>
        <div className='about_container_One'>
          <h1>
            <span className="icon-wrapper">
              <FaHistory className="section-icon" />
            </span>
            {translate('ourHistory')}
          </h1>
          <h2>{translate('associationName')}</h2>
          <p>{translate('description')}</p>
        </div>
        <div className='about_container_Two'>
          <div className='about_container_Two_One'>
            <h2>
              <FaPeopleCarry className="mission-icon" />
              {translate('ourMission')}
            </h2>
            <h3>
              <FaChild className="mission-desc-icon" />
              {translate('missionDesc')}
            </h3>
          </div>
          <div className='about_container_Two_Two'>
            <div className="stat-item">
              <h1>2012</h1>
              <p>
                <FaCalendarAlt className="stat-icon" />
                {translate('founded')}
              </p>
            </div>
            <div className="stat-item">
              <h1>{formatNumber(animatedViewed)}</h1>
              <p>
                <FaEye className="stat-icon" />
                {translate('views')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
